// Imports
import {
  Base, DataTypes, SubmitTypes, ErrorTypes
} from '@mixins/forms'
import { mapState, mapActions, mapGetters } from 'vuex'
import { getQueryParamByName } from '@utils/get-query-parameters'
import { getApiUrl } from '@utils/api-helpers'
import axios from 'axios'

// Parts
const { ObjectDataType: dataType } = DataTypes
const { CheckOutSubmit: submitType } = SubmitTypes
const { CheckOutError: errorHandling } = ErrorTypes

// In SBE Modify Booking Edit Mode in Booking Wizard restrict the tracking view
const pageHref = window.location.href
const fireFormTrackingView = getQueryParamByName(pageHref, 'bookingEditMode') !== 'true'

// Options
const options = {
  name: 'checkout-form',
  dataType,
  submitType,
  errorHandling,
  submitOnChange: false,
  skipValidation: false,
  tracking: {
    view: fireFormTrackingView,
    validation: true,
    externalValidation: true,
    submit: { events: { checkout: true } },
    error: true
  }
}

// Component
export default {
  name: options.name,
  mixins: [
    Base(options)
  ],
  computed: {
    ...mapState('cart', ['roomUpgradeSelected', 'roomUpgradePriceDifference']),
    ...mapState('modifyReservation', ['isBookingEditMode']),
    ...mapGetters('modifyReservation', ['currentReservationLookUpData']),
  },
  methods: {
    ...mapActions('booking', ['transformCheckOutData']),
    ...mapActions('modifyReservation', ['setReservationModifySuccessInSession', 'readReservation']),
    /**
    * Transforms the data before passing it
    * to the submit action.
    */
    async transformData(data) {
      const vgsForm = this.$children.filter((item) => item?.$el?.className.includes('vgs-form'))[0] || this.$children.filter((item) => item?.$refs?.vgsForm)[0]?.$refs?.vgsForm
      const transformData = await this.transformCheckOutData(data)

      if (transformData.directBill === 'true') {
        data.cardNumber = ''
        data.cardHolderName = ''
        data.cardCode = ''
        data.cardExpirateDate = ''
      }
      if ((this.isBookingEditMode && !vgsForm && transformData.baseCheckOutInfo.existingCardSelected) || !vgsForm) {
        return transformData
      }
      if (!vgsForm || vgsForm.name !== 'vgs-form') {
        this.serverErrors.push({
          code: 500,
          message: 'Error: VGS not implemented!'
        })
        throw new Error('Error: VGS not implemented!')
      }
      if (this.isBookingEditMode) {
        transformData.isBookingEditMode = true
      }
      // add check for edit mode
      const tokenizedData = await vgsForm.submit(transformData)
      this.$logger.debug('tokenizedData: ', tokenizedData)
      return tokenizedData
    },
    /**
    * Transforms the response.
    */
    async transformResponse(data) {
      this.$logger.debug('redirectUrl: ', this.redirectUrl)
      this.$logger.debug('data: ', data)
      this.$store.commit('booking/CHECK_OUT_PENDING', true)
      const originParam = getQueryParamByName(window.location.href, 'origin')
      const orderNumbers = this.getOrderNumbers(data)
      if (data.success) {
        try {
          const resResponse = await axios.post(getApiUrl('/api/v1/booking/add-reservations'),
            {
              Numbers: orderNumbers,
              UpgradePriceDifferencePerNight: this.roomUpgradeSelected ? this.roomUpgradePriceDifference : null,
            })

          if (resResponse.data.success) {
            if (this.isBookingEditMode) {
              const readReservationData = await this.readReservation({
                lookUpDataObject: this.currentReservationLookUpData,
                saveOldReservation: true
              })
              if (readReservationData?.reservations?.length) {
                this.setReservationModifySuccessInSession()
                window.location.href = this.redirectUrl
              } else {
                this.$store.commit('booking/CHECK_OUT_PENDING', false)
                throw new Error('ReadReservation unexpected error.')
              }
            } else {
              window.location.href = `${this.redirectUrl}?confirmation_number=${data.orderNumber.join(',')}&origin=${originParam}`
            }
          } else {
            this.$store.commit('booking/CHECK_OUT_PENDING', false)

            throw new Error(resResponse.data.errorMessage)
          }
        } catch (error) {
          this.$store.commit('booking/CHECK_OUT_PENDING', false)
          this.$logger.error(error)
          throw error
        }
      } else {
        throw data
      }
    },
    getOrderNumbers(data) {
      if (this.isBookingEditMode) {
        return data.reservations.map((reservation) => reservation.modifyReservations.id)
      }
      return data.orderNumber
    },
  }
}
